import { useContext, useMemo } from "react";
import { SecurityObjectContext } from "../security/SecurityObjectProvider";
import { PermissionType } from "../types/security";
import { normalizePath } from "../security/SecurityObjectProvider";

export default function useSecurityObject() {
    const { byCode, byRoute, reload } = useContext(SecurityObjectContext);

    const isLoadingPermissions = useMemo(
        () => byCode === null || byRoute === null,
        [byCode, byRoute],
    );

    const getByCode = (objectCode: string) => {
        if (!byCode) return undefined; // loading -> undefined
        return byCode[objectCode];
    };

    const getByRoute = (path: string) => {
        if (!byRoute) return undefined; // loading -> undefined
        return byRoute[normalizePath(path)];
    };

    const getPermissionType = (objectCode: string): PermissionType => {
        if (!byCode) return PermissionType.None; // loading -> deny
        return byCode[objectCode]?.tipoPermiso ?? PermissionType.Write;
    };

    const hasReadPermission = (objectCode: string) => {
        const p = getPermissionType(objectCode);
        return p === PermissionType.Read || p === PermissionType.Write;
    };

    const hasWritePermission = (objectCode: string) => {
        const p = getPermissionType(objectCode);
        return p === PermissionType.Write;
    };

    return {
        hasReadPermission,
        hasWritePermission,
        getPermissionType,
        getByCode,
        getByRoute,
        isLoadingPermissions,
        reloadSecurityObjects: reload,
    };
}
